<template>
    <div class="notification">
        <div class="notification_header">
            <div class="notification_headerIcon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
                </svg>
            </div>
            <div class="notification_headerContent">
                <h2>Notificações</h2>
                <span class="notification_badge">3 novas</span>
            </div>
        </div>

        <div class="notification_container">
            <div class="notification_content" v-for="(notification, index) in notifications" :key="index">
                <div class="notification_contentIcon">
                    <div class="notification_iconCircle" :class="notification.type">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" v-if="notification.type === 'post'">
                            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                        </svg>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" v-else-if="notification.type === 'campaign'">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                        </svg>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" v-else>
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                        </svg>
                    </div>
                </div>
                <div class="notification_contentText">
                    <h3>{{ notification.title }}</h3>
                    <p>{{ notification.message }}</p>
                    <span class="notification_time">{{ notification.time }}</span>
                </div>
                <div class="notification_actions" v-if="!notification.read">
                    <div class="notification_unreadDot"></div>
                </div>
            </div>
        </div>

        <div class="notification_footer">
            <button class="notification_footerBtn">Ver todas as notificações</button>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const notifications = ref([
    {
        type: 'post',
        title: 'Novo Post',
        message: 'Teve um novo post em - Gatilhos mentais na prática',
        time: 'há 2 minutos',
        read: false
    },
    {
        type: 'post',
        title: 'Novo Post',
        message: 'Teve um novo post em - Gatilhos mentais na prática',
        time: 'há 5 minutos',
        read: false
    },
    {
        type: 'campaign',
        title: 'Nova Campanha',
        message: 'Uma nova campanha foi criada para aprovação',
        time: 'há 10 minutos',
        read: false
    },
    {
        type: 'post',
        title: 'Novo Post',
        message: 'Teve um novo post em - Gatilhos mentais na prática',
        time: 'há 15 minutos',
        read: true
    },
    {
        type: 'info',
        title: 'Sistema Atualizado',
        message: 'O sistema foi atualizado com novas funcionalidades',
        time: 'há 1 hora',
        read: true
    }
]);
</script>

<style lang="scss" scoped>
    .notification{
        cursor: initial;
        width: 420px;
        position: absolute;
        top: 34px;
        right: 8px;
        background: var(--backgroundCard);
        border-radius: var(--borderRadiusLarge);
        box-shadow: var(--boxShadowLarge);
        z-index: 1000;
        overflow: hidden;
        animation: slideDown 0.3s ease-out;
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    .notification_header{
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, var(--colorGreen) 0%, var(--colorGreenDark) 100%);
        padding: 24px;
        color: var(--textWhite);
        
        .notification_headerIcon {
            margin-right: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 12px;
            backdrop-filter: blur(10px);
        }

        .notification_headerContent {
            flex: 1;
            
            h2 {
                font-size: 18px;
                font-weight: 600;
                margin: 0 0 4px 0;
                line-height: 1.2;
            }

            .notification_badge {
                font-size: 13px;
                font-weight: 500;
                opacity: 0.9;
            }
        }
    }

    .notification_container{
        max-height: 360px;
        overflow-y: auto;
        
        &::-webkit-scrollbar {
            width: 4px;
        }
        
        &::-webkit-scrollbar-track {
            background: var(--borderColorLight);
        }
        
        &::-webkit-scrollbar-thumb {
            background: var(--borderColorDark);
            border-radius: 2px;
            
            &:hover {
                background: var(--textMuted);
            }
        }
    }
    
    .notification_content{
        display: flex;
        align-items: flex-start;
        padding: 20px 24px;
        border-bottom: 1px solid var(--borderColorLight);
        transition: var(--transitionDefault);
        position: relative;

        &:hover {
            background: var(--backgroundHover);
        }

        &:last-child{
            border-bottom: none;
        }

        .notification_contentIcon {
            margin-right: 16px;
            flex-shrink: 0;

            .notification_iconCircle {
                width: 40px;
                height: 40px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: var(--textWhite);

                &.post {
                    background: linear-gradient(135deg, var(--colorBlue) 0%, var(--colorBlueDark100) 100%);
                }

                &.campaign {
                    background: linear-gradient(135deg, var(--colorOrange) 0%, var(--colorOrangeDark100) 100%);
                }

                &.info {
                    background: linear-gradient(135deg, var(--colorBlue) 0%, var(--colorBlueDark100) 100%);
                }
            }
        }

        .notification_contentText {
            flex: 1;
            min-width: 0;

            h3 {
                font-size: 15px;
                font-weight: 600;
                color: var(--textPrimary);
                margin: 0 0 6px 0;
                line-height: 1.3;
            }

            p {
                font-size: 14px;
                font-weight: 400;
                color: var(--textSecondary);
                margin: 0 0 8px 0;
                line-height: 1.4;
                word-wrap: break-word;
            }

            .notification_time {
                font-size: 12px;
                font-weight: 500;
                color: var(--textMuted);
            }
        }

        .notification_actions {
            margin-left: 12px;
            flex-shrink: 0;
            display: flex;
            align-items: flex-start;
            padding-top: 2px;

            .notification_unreadDot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: var(--colorBlue);
                animation: pulse 2s infinite;
            }

            @keyframes pulse {
                0%, 100% {
                    opacity: 1;
                }
                50% {
                    opacity: 0.5;
                }
            }
        }
    }

    .notification_footer {
        padding: 16px 24px 20px;
        background: var(--backgroundHover);
        border-top: 1px solid var(--borderColorLight);

        .notification_footerBtn {
            width: 100%;
            background: transparent;
            border: 2px solid var(--borderColorMedium);
            color: var(--textSecondary);
            font-size: 14px;
            font-weight: 600;
            padding: 12px 16px;
            border-radius: var(--borderRadiusMedium);
            cursor: pointer;
            transition: var(--transitionDefault);

            &:hover {
                background: var(--colorGreen);
                color: var(--textWhite);
                border-color: var(--colorGreen);
                transform: translateY(-1px);
            }

            &:active {
                transform: translateY(0);
            }
        }
    }
</style>